import React from "react";
import { UnconfirmedStage } from "@greeter-venue/components/ConfirmSwiper/UnconfirmedStage";
import { LoadingStage } from "@greeter-venue/components/ConfirmSwiper/LoadingStage";
import { DoneStage } from "@greeter-venue/components/ConfirmSwiper/DoneStage";
import { doNothing, classNames } from "@greeter/util";
import { ConfirmStage } from "@greeter-venue/components/ConfirmSwiper/ConfirmSwiper";

import css from "./ArrivedSwiper.module.scss";

export type ArrivedSwiperProps = {
  stage: ConfirmStage;
  onMarkAsArrived?: () => void;
  disabled?: boolean;
  className?: string;

  text?: string;
}

function renderStage(stage: ConfirmStage, onMarkAsArrived: () => void, text: string = "Ankommet") {
  switch (stage) {
    case "unconfirmed":
      return (
        <UnconfirmedStage
          onAccept={onMarkAsArrived}
          text={text}
          {...classNames(css.UnconfirmedStage)}
        />
      );
    case "loading":
      return <LoadingStage text={text} className={css.LoadingStage} />;
    case "done":
      return <DoneStage text="Sådan!" className={css.DoneStage} />;
  }
}

export const ArrivedSwiper: React.FC<ArrivedSwiperProps> = ({
  stage,
  onMarkAsArrived = doNothing,
  className,
  disabled = false,
  text
}) => {
  return (
    <div className={disabled ? classNames(className, css.Disabled).className : className}>
      {renderStage(stage, onMarkAsArrived, text)}
    </div>
  );
};

export default ArrivedSwiper;
export type { ConfirmStage as ArrivedStage };
